import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { SidebarBaseComponent } from 'src/app/shared/components/master-detail-layout/sidebar-base/sidebar-base.component';
import { SidebarItemComponent } from 'src/app/shared/components/master-detail-layout/sidebar-item/sidebar-item.component';
import { SidebarSectionComponent } from 'src/app/shared/components/master-detail-layout/sidebar-section/sidebar-section.component';

import type { SettingsCategory } from '../../models/settings-hub.model';

/** Collapsible groups of subcategories; a group opens again whenever the page navigates to one of its subcategories */
@Component({
    selector: 'app-settings-sidebar',
    standalone: true,
    imports: [
        MatIconModule,
        SidebarBaseComponent,
        SidebarItemComponent,
        SidebarSectionComponent,
        TranslateModule
    ],
    templateUrl: './settings-sidebar.component.html'
})
export class SettingsSidebarComponent {
    @Input({ required: true }) categories!: SettingsCategory[];
    @Input() selectedSubcategoryId: string | null = null;
    /** Changes every time the page navigates to a subcategory: the group that contains it is expanded */
    @Input() navigationCount = 0;
    /** Subcategories with changes not saved: they get a red dot */
    @Input() changedSubcategoryIds: ReadonlySet<string> = new Set();
    @Output() subcategorySelect = new EventEmitter<string>();

    /** True when a subcategory of the category has changes not saved: the dot is also shown on the group, because it may be collapsed */
    protected hasChanges(category: SettingsCategory) {
        return category.subcategories.some(subcategory => this.changedSubcategoryIds.has(subcategory.id));
    }

    protected hasSelected(category: SettingsCategory) {
        return category.subcategories.some(subcategory => subcategory.id === this.selectedSubcategoryId);
    }
}
